module.exports = __webpack_public_path__ + "static/media/4.a4e5e356.gif";